import React from "react"
import styled from "styled-components"

const CheckboxWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Checkbox = ({
  checked = false,
  onChange,
  uncheckIconFill = "white",
}: {
  checked?: boolean
  onChange?: (checked: boolean) => void
  uncheckIconFill?: string
}) => {
  return (
    <CheckboxWrapper
      onClick={() => {
        onChange?.(!checked)
      }}
    >
      {checked ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_9675_45209)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM9.97661 15.694C9.96937 15.686 9.96226 15.678 9.9553 15.6699L7.27935 12.7384C6.90688 12.3304 6.90689 11.6688 7.27935 11.2608C7.65181 10.8528 8.25568 10.8528 8.62815 11.2608L10.6514 13.4772L15.3718 8.30602C15.7443 7.89799 16.3481 7.89799 16.7206 8.30602C17.0931 8.71405 17.0931 9.37559 16.7206 9.78361L11.3257 15.6936L11.3254 15.694C10.953 16.102 10.3491 16.102 9.97661 15.694Z"
              fill="#2CCCD3"
            />
          </g>
          <defs>
            <clipPath id="clip0_9675_45209">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_9675_45218)">
            <path
              d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
              fill={uncheckIconFill}
            />
          </g>
          <defs>
            <clipPath id="clip0_9675_45218">
              <rect width="24" height="24" fill={uncheckIconFill} />
            </clipPath>
          </defs>
        </svg>
      )}
    </CheckboxWrapper>
  )
}

export default Checkbox
